import { useState } from "react";
import { getNewsletterOptions } from "../../../_mock-api's/index";
import { FormattedMessage, useIntl } from "react-intl";

const NotificationSettings = () => {
  
  const intl = useIntl();

  const [settings, setSettings] = useState({
    NotifyOnLogin: false,
    BookingAssistReminders: false,
    bookingPromotions: false,
    TripInformationAndOffers: false,
    SmsForPayments: false,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    setSettings((prevState) => ({
      ...prevState,
      [id]: checked,
    }));
  };

  // Generate switchOptions based on the current settings state
  const switchOptions = [
    {
      id: "NotifyOnLogin",
      label: intl.formatMessage({ id: "notify.email" }),
      checked: settings.NotifyOnLogin,
    },
    {
      id: "BookingAssistReminders",
      label: intl.formatMessage({ id: "notify.reminders" }),
      checked: settings.BookingAssistReminders,
    },
    {
      id: "bookingPromotions",
      label: intl.formatMessage({ id: "notify.promotions" }),
      checked: settings.bookingPromotions,
    },
    {
      id: "TripInformationAndOffers",
      label: intl.formatMessage({ id: "notify.offers" }),
      checked: settings.TripInformationAndOffers,
    },
    {
      id: "SmsForPayments",
      label: intl.formatMessage({ id: "notify.sms" }),
      checked: settings.SmsForPayments,
    },
  ];

  const newsletterOptions = getNewsletterOptions(intl);

  return (
    <div className="card shadow-sm border mb-5">
      <div className="card-header border-bottom">
        <h4 className="card-header-title">
          <i className="bi bi-bell mx-2"></i><FormattedMessage id="notifications" />
        </h4>
      </div>

      <form className="card-body">
        <div className="mb-4">
          <label className="form-label">
            <FormattedMessage id="newsletter" /><span className="text-danger">*</span>
          </label>
          <div className="d-flex gap-2 gap-sm-4 flex-wrap">
            {newsletterOptions?.map((option) =>
              renderRadioOption("newsletter", option.label, option.isChecked)
            )}
          </div>
        </div>

        {switchOptions?.map((option) =>
          renderSwitch(option.id, option.label, option.checked)
        )}
      </form>
    </div>
  );

  function renderRadioOption(name: string, label: string, isChecked: boolean) {
    return (
      <div className="form-check radio-bg-light" key={`${name}-${label}`}>
        <input
          className="form-check-input"
          type="radio"
          name={name}
          id={`${name}-${label}`}
          defaultChecked={isChecked}
        />
        <label className="form-check-label" htmlFor={`${name}-${label}`}>
          {label}
        </label>
      </div>
    );
  }

  function renderSwitch(id: string, label: string, checked: boolean) {
    return (
      <div
        className="form-check form-switch form-check-md d-flex justify-content-between mb-4"
        key={id}
      >
        <label className="form-check-label ps-0 pe-4" htmlFor={id}>
          {label}
        </label>
        <input
          type="checkbox"
          className="form-check-input"
          id={id}
          checked={checked}
          onChange={handleChange}
        />
      </div>
    );
  }
};

export default NotificationSettings;
